import type { Casino } from "@/lib/types";

/**
 * Logostrip voor de hero van reviewpagina's: de geteste aanbieders uit de
 * casinolijst, direct bovenaan zichtbaar voor vertrouwen. Enkel op reviews.
 */
export function ReviewCasinoLogos({
  casinos,
  contextLabel,
}: {
  casinos: Casino[];
  contextLabel: string;
}) {
  const shown = casinos.slice(0, 5);
  if (shown.length === 0) return null;

  return (
    <div className="mt-6 border-t border-border/60 pt-5">
      <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{contextLabel}</p>
      <ul className="mt-3 flex flex-wrap items-center gap-2" aria-label="Aanbieders uit onze casinolijst">
        {shown.map((casino) => (
          <li key={casino.id}>
            <span className="flex h-11 items-center rounded-lg border border-border bg-card px-3 shadow-[0_8px_20px_-12px_rgba(15,42,84,0.25)]">
              {casino.logo_url ? (
                <img
                  src={casino.logo_url}
                  alt={`Logo van ${casino.name}`}
                  width={84}
                  height={22}
                  loading="eager"
                  decoding="async"
                  className="max-h-[22px] w-auto object-contain"
                />
              ) : (
                <span className="text-xs font-semibold text-foreground">{casino.name}</span>
              )}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
